module.exports = __webpack_public_path__ + "assets/img/zh3.be56ffa5.png";